import { render, staticRenderFns } from "./info-form.vue?vue&type=template&id=752198a6&scoped=true"
import script from "./info-form.vue?vue&type=script&lang=js"
export * from "./info-form.vue?vue&type=script&lang=js"
import style0 from "./info-form.vue?vue&type=style&index=0&id=752198a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752198a6",
  null
  
)

export default component.exports